import { useNavigate, useRouterState } from "@tanstack/react-router";
import { OverlaySchema } from "@/components/overlays";

export function useOverlay() {
  const navigate = useNavigate();
  const router = useRouterState();

  return {
    open: (...overlay: Exclude<OverlaySchema, undefined>) => {
      return navigate({
        to: router.location.pathname,
        search: (prev) => ({ ...prev, overlay }),
        params: (prev) => prev,
      });
    },
    close: () => {
      return navigate({
        to: router.location.pathname,
        search: (prev) => ({ ...prev, overlay: undefined }),
        params: (prev) => prev,
      });
    },
  };
}
